/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
} from '@material-ui/core';
import {
  verifyUserAttribute,
  verifyUserAttributeSubmit,
  selectIsUnverifiedEmail,
  selectIsPending,
} from '../../store/authSlice';
import {
  isRequired,
  validateField,
  validateForm,
} from '../../helpers/validation';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  elementHidden: {
    display: 'none',
  },
}));

export default function EmailVerificationForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isPending = useSelector(selectIsPending);
  const isUnverifiedEmail = useSelector(selectIsUnverifiedEmail);
  const [formErrors, setFormErrors] = useState({});
  const [verificationCode, setVerificationCode] = useState('');

  const formRules = {
    verificationCode: [isRequired],
  };

  const handleVerificationCodeChange = (event) => {
    setVerificationCode(event.target.value);
  };

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const attemptVerifyUserAttributeSubmit = (event) => {
    event.preventDefault();
    if (validateForm(formRules, { verificationCode }, formErrors, setFormErrors)) {
      dispatch(verifyUserAttributeSubmit({ attribute: 'email', code: verificationCode }));
    }
  };

  useEffect(() => {
    if (isUnverifiedEmail) {
      dispatch(verifyUserAttribute({ attribute: 'email' }));
    }
  }, [isUnverifiedEmail, dispatch]);

  return (
    <>
      <p>A verification code has been sent to your registered email address.</p>
      <form className={classes.form} noValidate>
        <TextField
          variant="outlined"
          margin="normal"
          id="verification-code"
          label="Verification Code"
          name="verificationCode"
          autoComplete="one-time-code"
          value={verificationCode}
          error={!!formErrors.verificationCode}
          helperText={formErrors.verificationCode}
          onChange={handleVerificationCodeChange}
          onBlur={handleBlur}
          disabled={isPending}
          fullWidth
          required
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={attemptVerifyUserAttributeSubmit}
          disabled={isPending}
          fullWidth
        >
          Verify Email
        </Button>
      </form>
    </>
  );
}
